import type { SpecificationParagraph } from '../types/specification-gen-content';
import { SpecificationContentType } from '../enums';
import type { SpecificationStreamProvider } from '../types/specification';

export const SpecificationSection = Symbol('SpecificationSection');

export interface SpecificationSection<T extends SpecificationParagraph = SpecificationParagraph, P = any> {
    /**
     * 获取段落内容类型
     */
    readonly contentType?: SpecificationContentType | string;

    /**
     * 准备数据，有的要准备参数的
     */
    prepare?(data: P): Promise<any> | any;

    /**
     * 执行内容生成前的预处理
     */
    beforeGenerate?(): Promise<any> | any;

    /**
     * 生成内容
     * @param regenerate 是否重新生成
     */
    generate?(regenerate?: boolean): Promise<any> | any;

    /**
     * 执行内容生成后的后处理
     */
    afterGenerate?(): Promise<any> | any;

    /**
     * 更新内容
     * @param content 内容
     */
    updateContent(content: T): T;

    /**
     * 执行内容生成
     * @param regenerate 是否重新生成
     */
    execute(regenerate?: boolean): SpecificationStreamProvider<T>;

    /**
     * 保存内容到服务端
     */
    save?(p: T): Promise<any> | any;

    /**
     * 删除内容
     */
    remove?(p: T): Promise<any> | any;

    /**
     * 停止内容生成
     */
    stop(): any;
}
